"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertSeverityEnum = exports.AcuteEventConfidence = exports.acuteEventConfidenceEnum = exports.metricClassEnum = exports.changeEventAttributionTypeEnum = exports.ChangeEventDirection = exports.changeEventDirectionEnum = exports.AlertType = exports.alertTypeEnum = exports.clinicalRelevanceEnum = exports.EvidenceStrength = exports.evidenceStrengthEnum = exports.trimesterEnum = exports.budgetLevelEnum = exports.effortLevelEnum = exports.makeupEnum = exports.outdoorsEnum = exports.pregnancyEnum = exports.skinSensitivityEnum = exports.skinPatternsEnum = exports.genderEnum = exports.recommendationStatusEnum = exports.qualitySensitivityEnum = exports.adherenceLevelEnum = exports.routineRemovalReasonEnum = exports.routineAdjustmentTypeEnum = exports.safetyNoteTypeEnum = exports.productSourceEnum = exports.attributionRecommendationEnum = exports.concernAttributionTypeEnum = exports.concernCoverageStatusEnum = exports.lifestyleQualityEnum = exports.lifestyleSourceEnum = exports.lifestyleFactorEnum = exports.routineConsiderationTypeEnum = exports.routineGapPriorityEnum = exports.productTimelineStatusEnum = exports.regionalVsFaceEnum = exports.treatmentSlugEnum = exports.treatmentCategoryEnum = exports.treatmentAreaEnum = exports.areaEnum = exports.techNameEnum = exports.metricGroupEnum = exports.domainEnum = exports.scanReminderAnchorEnum = exports.timePeriodEnum = exports.dayOfWeekEnum = exports.DEFAULT_SUPPORTED_LOCALE = exports.supportedLocaleEnum = void 0;
exports.cycleTrackingTypeEnum = exports.lifestyleAnswerSourceEnum = exports.lifestyleQuestionEnum = exports.adherenceSelectionEnum = exports.adherenceAnswerTypeEnum = exports.cycleLengthCategoryEnum = exports.menstrualPhaseEnum = exports.hemisphereEnum = exports.seasonEnum = exports.notificationTypeEnum = exports.routineChangeImpactEnum = exports.routineEventTypeEnum = exports.SUGGESTION_TYPE = exports.suggestionTypeEnum = exports.routineVerdictEnum = exports.routineEndReasonEnum = exports.routineMarkStatusEnum = exports.periodEnum = exports.schedulePeriodEnum = exports.routineSlotEnum = exports.routineItemTypeEnum = exports.scanStatusEnum = exports.scanFileTypeEnum = exports.metricRatingEnum = exports.metricValueTypeEnum = exports.metricStateEnum = exports.analysisQualityEnum = exports.baselineMethodEnum = void 0;
const constants_1 = require("../constants");
exports.supportedLocaleEnum = ['en-US', 'en-AU'];
exports.DEFAULT_SUPPORTED_LOCALE = 'en-AU';
exports.dayOfWeekEnum = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
];
exports.timePeriodEnum = ['AM', 'PM'];
/**
 * Scan reminder habit anchors — the everyday habit a user stacks their daily
 * scan onto (the "pick a habit to scan near" step of the post-reveal reminder
 * flow). Type-safe key set shared by backend + frontend; stored loosely as a
 * nullable text column on `scan_plan` (see the schema), so the column never
 * needs an `ALTER TYPE` as this list evolves. Presentation (label, icon, seed
 * time) lives in the frontend const keyed by `ScanReminderAnchor`.
 */
exports.scanReminderAnchorEnum = [
    'waking_up',
    'brushing_teeth',
    'after_shower',
    'lunch_break',
    'after_gym',
    'winding_down',
];
exports.domainEnum = [
    'skin',
    'sleep',
    'nutrition',
    'body',
    'menstruation',
    'daily_health',
];
exports.metricGroupEnum = [
    constants_1.SkinMetricGroup.skin_sensitivity,
    constants_1.SkinMetricGroup.clarity_breakouts,
    constants_1.SkinMetricGroup.tone_evenness,
    constants_1.SkinMetricGroup.structure_aging,
    constants_1.SkinMetricGroup.eye_area,
    constants_1.SkinMetricGroup.baseline_properties,
];
exports.techNameEnum = [
    // GROUP 1: Skin Sensitivity
    constants_1.SkinMetricTechName.hydration,
    constants_1.SkinMetricTechName.texture_roughness,
    constants_1.SkinMetricTechName.redness,
    constants_1.SkinMetricTechName.surface_sebum,
    constants_1.SkinMetricTechName.telangiectasia,
    // GROUP 2: Clarity & Breakouts
    constants_1.SkinMetricTechName.breakouts,
    constants_1.SkinMetricTechName.pores,
    constants_1.SkinMetricTechName.pie,
    // GROUP 3: Tone Evenness
    constants_1.SkinMetricTechName.pigmentation,
    constants_1.SkinMetricTechName.sun_spots,
    constants_1.SkinMetricTechName.melasma,
    constants_1.SkinMetricTechName.freckles,
    // GROUP 4: Structure & Aging
    constants_1.SkinMetricTechName.lines,
    constants_1.SkinMetricTechName.fine_lines,
    constants_1.SkinMetricTechName.deep_lines,
    constants_1.SkinMetricTechName.nasolabial_wrinkles,
    constants_1.SkinMetricTechName.marionette_lines,
    constants_1.SkinMetricTechName.sagging,
    constants_1.SkinMetricTechName.jowls,
    constants_1.SkinMetricTechName.age,
    // GROUP 5: Eye Area
    constants_1.SkinMetricTechName.dark_circles,
    constants_1.SkinMetricTechName.puffiness,
    constants_1.SkinMetricTechName.eye_bags,
    constants_1.SkinMetricTechName.lacrimal_grooves,
    constants_1.SkinMetricTechName.eyes_age,
    // GROUP 6: Baseline Properties
    constants_1.SkinMetricTechName.skin_type,
    constants_1.SkinMetricTechName.ita,
    constants_1.SkinMetricTechName.skintone,
    // COMPOSITE METRICS
    constants_1.SkinMetricTechName.sensitivity_composite,
    // DEPRECATED (keep for backward compatibility)
    constants_1.SkinMetricTechName.enlarged_pores,
    constants_1.SkinMetricTechName.inflammation,
    constants_1.SkinMetricTechName.irritation,
    constants_1.SkinMetricTechName.pimples,
    constants_1.SkinMetricTechName.uniformness,
    constants_1.SkinMetricTechName.translucency,
    constants_1.SkinMetricTechName.moles,
    constants_1.SkinMetricTechName.pigmentation_composite,
];
exports.areaEnum = [
    constants_1.SkinMetricAreaName.face,
    constants_1.SkinMetricAreaName.nose,
    constants_1.SkinMetricAreaName.forehead,
    constants_1.SkinMetricAreaName.left_eye,
    constants_1.SkinMetricAreaName.right_eye,
    constants_1.SkinMetricAreaName.left_cheek,
    constants_1.SkinMetricAreaName.right_cheek,
    constants_1.SkinMetricAreaName.perioral,
    constants_1.SkinMetricAreaName.upper_lip,
    constants_1.SkinMetricAreaName.chin,
    constants_1.SkinMetricAreaName.jawline,
    constants_1.SkinMetricAreaName.t_zone,
    constants_1.SkinMetricAreaName.u_zone,
];
exports.treatmentAreaEnum = [
    constants_1.TreatmentAreaName.face,
    constants_1.TreatmentAreaName.nose,
    constants_1.TreatmentAreaName.forehead,
    constants_1.TreatmentAreaName.left_eye,
    constants_1.TreatmentAreaName.right_eye,
    constants_1.TreatmentAreaName.left_cheek,
    constants_1.TreatmentAreaName.right_cheek,
    constants_1.TreatmentAreaName.t_zone,
    constants_1.TreatmentAreaName.u_zone,
    constants_1.TreatmentAreaName.neck,
    constants_1.TreatmentAreaName.jawline,
    constants_1.TreatmentAreaName.lips,
    constants_1.TreatmentAreaName.chin,
    constants_1.TreatmentAreaName.body,
    // Deprecated but keep for backward compatibility
    constants_1.TreatmentAreaName.perioral,
];
exports.treatmentCategoryEnum = [
    constants_1.TreatmentCategory.medical_aesthetics,
    constants_1.TreatmentCategory.facial_treatments,
    constants_1.TreatmentCategory.skin_treatments,
    constants_1.TreatmentCategory.body_treatments,
    constants_1.TreatmentCategory.wellness_specialised_treatments,
];
exports.treatmentSlugEnum = [
    constants_1.TreatmentSlug.anti_wrinkle,
    constants_1.TreatmentSlug.dermal_fillers,
    constants_1.TreatmentSlug.skin_boosters,
    constants_1.TreatmentSlug.bioremodelling,
    constants_1.TreatmentSlug.pdo_threads,
    constants_1.TreatmentSlug.collagen_stimulators,
    constants_1.TreatmentSlug.fat_dissolving_injections,
    constants_1.TreatmentSlug.facials,
    constants_1.TreatmentSlug.acne_treatments,
    constants_1.TreatmentSlug.hydrafacial,
    constants_1.TreatmentSlug.chemical_peels,
    constants_1.TreatmentSlug.microdermabrasion,
    constants_1.TreatmentSlug.led_light_therapy,
    constants_1.TreatmentSlug.microneedling,
    constants_1.TreatmentSlug.plasma_pen,
    constants_1.TreatmentSlug.oxygen_facials,
    constants_1.TreatmentSlug.exosomes,
    constants_1.TreatmentSlug.rejuran,
    constants_1.TreatmentSlug.laser_skin_resurfacing,
    constants_1.TreatmentSlug.ipl,
    constants_1.TreatmentSlug.nctf_skin_booster,
    constants_1.TreatmentSlug.prp_skin,
    constants_1.TreatmentSlug.fat_freezing,
    constants_1.TreatmentSlug.ultrasonic_fat_cavitation,
    constants_1.TreatmentSlug.rf_microneedling,
    constants_1.TreatmentSlug.hifu,
    constants_1.TreatmentSlug.muscle_defining,
    constants_1.TreatmentSlug.iv_vitamin_infusions,
];
/**
 * Regional vs Face comparison for unified skin report analysis
 * - 'better': Region is healthier than face average
 * - 'similar': Region aligns with face-level assessment
 * - 'worse': Region is more affected than face average
 * - 'not_applicable': Used for face entry itself (face IS the baseline)
 */
exports.regionalVsFaceEnum = [
    'better',
    'similar',
    'worse',
    'not_applicable',
];
// ============================================================================
// Stage 3: Routine Context Analysis Enums
// ============================================================================
/**
 * Product Timeline Status
 *
 * Timeline status for evaluating product effectiveness based on biological timelines.
 * - too_early: Less than minimum efficacy window (e.g., <4 weeks for most products)
 * - in_evaluation: Within efficacy window, watching for results
 * - established: Past efficacy window, effects should be visible
 */
exports.productTimelineStatusEnum = [
    'too_early',
    'in_evaluation',
    'established',
];
/**
 * Routine Gap Priority
 *
 * Priority level for routine gaps (concerns without adequate routine support).
 * - high: Major concern with no routine support
 * - medium: Moderate concern or only partial support
 * - low: Minor gap or optional enhancement
 */
exports.routineGapPriorityEnum = ['high', 'medium', 'low'];
/**
 * Routine Consideration Type
 *
 * Types of routine considerations for product interactions.
 * - positive_synergy: Products work well together (e.g., Vitamin C + SPF)
 * - potential_conflict: Products may interact negatively (e.g., Retinol + AHA same night)
 * - timing_recommendation: Order/timing suggestion for products
 * - usage_optimization: Frequency or application optimization tip
 */
exports.routineConsiderationTypeEnum = [
    'positive_synergy',
    'potential_conflict',
    'timing_recommendation',
    'usage_optimization',
];
/**
 * Lifestyle Factor
 *
 * Lifestyle factors that can impact skin health.
 */
exports.lifestyleFactorEnum = [
    'sleep',
    'stress',
    'diet',
    'adherence',
    'menstrual_cycle',
];
/**
 * Lifestyle Source
 *
 * Source of lifestyle data.
 * - calculated: Derived from journal/tracking data
 * - user_reported: Manually selected by user in wizard
 */
exports.lifestyleSourceEnum = ['calculated', 'user_reported'];
/**
 * Lifestyle Quality
 *
 * Quality levels for lifestyle factors as reported in the wizard.
 */
exports.lifestyleQualityEnum = ['poor', 'inconsistent', 'good'];
/**
 * Concern Coverage Status
 *
 * How well a skin concern is addressed by the current routine.
 * - well_supported: Routine has appropriate products targeting this concern
 * - partially_supported: Some products help but not comprehensive
 * - not_addressed: No products in routine target this concern
 */
exports.concernCoverageStatusEnum = [
    'well_supported',
    'partially_supported',
    'not_addressed',
];
/**
 * Concern Attribution Type
 *
 * What is causing a concern's current state based on timeline analysis.
 * Used for dermatological reasoning about whether to intervene.
 *
 * - treatment_recovery: Concern is temporary due to recent professional treatment
 *   (e.g., redness after chemical peel, sensitivity after laser)
 * - product_purging: Concern is temporary purging from a new active
 *   (e.g., breakouts from new retinoid - expected weeks 2-6)
 * - product_adjustment: Skin adjusting to new product, may resolve
 *   (e.g., mild dryness from new AHA, typically resolves in 2-3 weeks)
 * - routine_effective: Current routine is actively addressing this concern
 *   (e.g., niacinamide addressing pores, just needs more time)
 * - genuine_gap: No routine/treatment explanation - needs intervention
 * - external_factor: Likely caused by lifestyle/environmental factors
 *   (e.g., stress-related breakouts, seasonal dryness)
 * - improving: Concern is already improving without intervention needed
 * - unknown: Cannot determine attribution with available data
 */
exports.concernAttributionTypeEnum = [
    'treatment_recovery',
    'product_purging',
    'product_adjustment',
    'routine_effective',
    'genuine_gap',
    'external_factor',
    'improving',
    'unknown',
];
/**
 * Attribution Recommendation
 *
 * What action to take based on the attribution analysis.
 * - wait: Let current routine/treatment take effect (do not recommend new products)
 * - monitor: Keep watching, may need intervention later
 * - address: Genuine gap that should be filled with product recommendation
 * - continue: Current approach is working, maintain it
 */
exports.attributionRecommendationEnum = [
    'wait',
    'monitor',
    'address',
    'continue',
];
// ============================================================================
// Stage 4: Recommendations Enums
// ============================================================================
/**
 * Product Source
 *
 * Source of a recommended product.
 * - stella: Product from Stella's curated catalog (clinical-grade)
 * - external: External product from PDB or other sources (budget-friendly)
 */
exports.productSourceEnum = ['stella', 'external'];
/**
 * Safety Note Type
 *
 * Type of safety concern for a recommendation.
 * - pregnancy: Ingredient contraindicated during pregnancy
 * - allergy: User has known allergy to ingredient
 * - interaction: Potential negative interaction between products
 */
exports.safetyNoteTypeEnum = [
    'pregnancy',
    'allergy',
    'interaction',
];
/**
 * Routine Adjustment Type
 *
 * Type of adjustment being recommended for an existing routine item.
 * - increase_frequency: Use more often (e.g., 2x/week → 4x/week)
 * - decrease_frequency: Use less often (e.g., daily → 3x/week)
 * - change_timing: Switch AM ↔ PM
 * - change_application: Change how it's applied (e.g., before/after another product)
 * - improve_adherence: Need to use more consistently (adherence issue, not product issue)
 */
exports.routineAdjustmentTypeEnum = [
    'increase_frequency',
    'decrease_frequency',
    'change_timing',
    'change_application',
    'improve_adherence',
];
/**
 * Routine Removal Reason
 *
 * Reason for recommending product removal from routine.
 * - ineffective: Not addressing concerns after adequate time (requires adherence ≥60%)
 * - causing_issues: Causing irritation, breakouts, or other problems
 * - redundant: Another product in routine does the same thing better
 * - conflict: Conflicts with a higher-priority product
 * - swap: Being replaced with a better alternative
 * - not_needed: User's skin has improved and no longer needs this
 * - safety: Safety concern (pregnancy, allergy discovered, etc.)
 */
exports.routineRemovalReasonEnum = [
    'ineffective',
    'causing_issues',
    'redundant',
    'conflict',
    'swap',
    'not_needed',
    'safety',
];
/**
 * Adherence Level
 *
 * Categorical adherence levels for routine evaluation.
 * Used to determine if a product can be evaluated for efficacy.
 * - highly_consistent: ≥80% adherence - can fully evaluate
 * - mostly_consistent: 60-79% adherence - can partially evaluate
 * - somewhat_consistent: 40-59% adherence - cannot evaluate efficacy
 * - inconsistent: 20-39% adherence - cannot evaluate efficacy
 * - very_inconsistent: <20% adherence - cannot evaluate efficacy
 * - not_applicable: As-needed products (spot treatments, masks)
 */
exports.adherenceLevelEnum = [
    'highly_consistent',
    'mostly_consistent',
    'somewhat_consistent',
    'inconsistent',
    'very_inconsistent',
    'not_applicable',
];
/**
 * Quality Sensitivity Level
 *
 * Indicates how much product quality/formulation matters for a given product category.
 * Used for budget-optimized product selection in Stage 4.
 *
 * - high: Always recommend clinical-grade (formulation matters significantly)
 *   Examples: serums, eye treatments, spot treatments, sunscreen
 * - medium: Recommend quality if budget allows
 *   Examples: moisturizers, exfoliants, toners
 * - low: Budget-friendly is fine for everyone (minimal quality difference)
 *   Examples: cleansers, makeup removers
 */
exports.qualitySensitivityEnum = ['high', 'medium', 'low'];
/**
 * Recommendation Status
 *
 * Lifecycle status of a product recommendation.
 * - active: Current recommendation, shown to user throughout app
 * - applied: User added the recommended product to their routine
 * - dismissed: User explicitly declined the recommendation
 * - superseded: A newer report generated new recommendations
 * - purchased: User purchased the product (if tracked)
 */
exports.recommendationStatusEnum = [
    'active',
    'applied',
    'dismissed',
    'superseded',
    'purchased',
];
// ============================================================================
// End Stage 4 Enums
// ============================================================================
exports.genderEnum = ['male', 'female', 'not_provided'];
exports.skinPatternsEnum = [
    'breakouts',
    'dry_itchy_patches',
    'red_easily',
    'dark_marks',
    'post_acne_marks',
    'sensitive_skin',
    'oily_skin',
    'dry_skin',
    'none',
];
exports.skinSensitivityEnum = [
    'very',
    'sometimes',
    'no',
    'not_sure',
];
exports.pregnancyEnum = ['yes', 'no', 'not_provided'];
exports.outdoorsEnum = ['high', 'medium', 'low'];
exports.makeupEnum = ['daily', 'sometimes', 'rarely', 'never'];
exports.effortLevelEnum = ['low', 'medium', 'high', 'not_sure'];
exports.budgetLevelEnum = ['low', 'medium', 'high'];
exports.trimesterEnum = ['first', 'second', 'third'];
// Statistical analysis enums
exports.evidenceStrengthEnum = [
    'very_strong',
    'strong',
    'moderate',
    'weak',
];
exports.EvidenceStrength = {
    VERY_STRONG: 'very_strong',
    STRONG: 'strong',
    MODERATE: 'moderate',
    WEAK: 'weak',
};
exports.clinicalRelevanceEnum = [
    'improvement',
    'worsening',
    'stable',
    'insufficient_data',
];
exports.alertTypeEnum = [
    'improvement',
    'worsening',
    'significant_change',
];
exports.AlertType = {
    IMPROVEMENT: 'improvement',
    WORSENING: 'worsening',
    SIGNIFICANT_CHANGE: 'significant_change',
};
/**
 * Change Event Direction
 *
 * Direction of a detected rapid skin change from the dual-track EMA system.
 * - improvement: Metric improved (fastEMA > slowEMA for positive metrics)
 * - worsening: Metric worsened (fastEMA < slowEMA for positive metrics)
 */
exports.changeEventDirectionEnum = ['improvement', 'worsening'];
exports.ChangeEventDirection = {
    IMPROVEMENT: 'improvement',
    WORSENING: 'worsening',
};
/**
 * Change Event Attribution Type
 *
 * Attribution type for skin metric change events based on timing relative
 * to environment shifts. Uses biology-aware lookback windows based on each
 * metric's half-life parameters.
 *
 * - skin_change: True skin change, no recent environment shift in lookback window
 * - environment_adjustment: Change detected within active shift phase (0 → 3× fast half-life)
 *   where fast EMA is still converging to new environment
 * - settling: Change detected in settling phase (3× fast → 2× slow half-life)
 *   where slow EMA is being pulled toward converged fast EMA
 */
exports.changeEventAttributionTypeEnum = [
    constants_1.ChangeEventAttribution.SKIN_CHANGE,
    constants_1.ChangeEventAttribution.ENVIRONMENT_ADJUSTMENT,
    constants_1.ChangeEventAttribution.SETTLING,
];
exports.metricClassEnum = ['fast', 'medium', 'slow'];
/**
 * Acute Event Confidence Tier
 *
 * Confidence level for acute skin change events from the dual-track EMA system.
 * Derived from consecutive scan count, trust weight, and magnitude ratio.
 * Requirements are metric-specific based on physiological stability.
 *
 * - low: Initial divergence detected, needs more confirmation
 * - moderate: Multiple scans confirm divergence, likely real change
 * - high: Strong evidence of acute change across multiple scans
 */
exports.acuteEventConfidenceEnum = ['low', 'moderate', 'high'];
exports.AcuteEventConfidence = {
    LOW: 'low',
    MODERATE: 'moderate',
    HIGH: 'high',
};
exports.alertSeverityEnum = ['low', 'medium', 'high', 'critical'];
exports.baselineMethodEnum = [
    'anchored',
    'rolling_fallback',
    'extended_fallback',
];
exports.analysisQualityEnum = ['early', 'partial', 'full'];
// Metric dashboard enums
exports.metricStateEnum = ['instant', 'trend'];
exports.metricValueTypeEnum = ['numeric', 'categorical'];
exports.metricRatingEnum = [
    'excellent',
    'good',
    'average',
    'needs_improvement',
];
exports.scanFileTypeEnum = [
    'original_image',
    'restored_image',
    'mask',
    'combined',
    'report',
];
exports.scanStatusEnum = [
    'processing', // Initial state (upload complete)
    'stage_1_complete', // Image assessment done
    'stage_2a_complete', // Face analysis done
    'completed', // Stage 2B done (final state)
    'stage_1_failed', // Failed during image assessment
    'stage_2a_failed', // Failed during face analysis
    'stage_2b_failed', // Failed during regional analysis
    'failed', // Generic/unknown failure
];
exports.routineItemTypeEnum = ['skincare', 'treatment'];
exports.routineSlotEnum = [
    'makeup_remover',
    'cleanser',
    'exfoliant',
    'toner',
    'serum',
    'spot_treatment',
    'face_mask',
    'eye_treatment',
    'lip_treatment',
    'moisturizer',
    'sunscreen',
    'aftersun',
    'neck_treatment',
    'EXCLUDE',
    'UNKNOWN',
];
exports.schedulePeriodEnum = ['am', 'pm', 'both'];
exports.periodEnum = ['am', 'pm'];
exports.routineMarkStatusEnum = [
    'completed',
    'skipped',
    'not_sure',
];
exports.routineEndReasonEnum = [
    'edited',
    'stopped_using',
    'deleted',
];
/**
 * The system's read on a closed observation window.
 *
 *   keep      → tracked metrics moved expected direction AND ≥1 crossed
 *               significance threshold AND no major confounders.
 *   fuzzy     → metrics didn't move meaningfully OR confounders were strong
 *               enough that signal can't be separated from noise.
 *   step_back → tracked metrics moved in the concerning direction past a
 *               threshold (comfort dip, barrier decline, etc.).
 */
exports.routineVerdictEnum = [
    'keep_using',
    'not_sure',
    'step_back',
];
/**
 * Routine-change suggestion types — the seven kinds Stella suggests.
 * Promoted to shared types so the frontend (`getSuggestionColor`) and the
 * weekly-report v3 motion schemas can reference a single source of truth.
 *
 * Order matches the routine tab's visual language (foundational/coverage
 * first, then usage tweaks, then ingredient adds).
 */
exports.suggestionTypeEnum = [
    'add_foundational',
    'add_ingredient',
    'frequency_increase',
    'frequency_decrease',
    'timing_change',
    'simplification',
];
/**
 * Const-style accessor map, e.g. `SUGGESTION_TYPE.ADD_FOUNDATIONAL`.
 * Kept alongside the enum array because backend services historically use
 * the const-map form. Both forms reference the same string values.
 */
exports.SUGGESTION_TYPE = {
    ADD_FOUNDATIONAL: 'add_foundational',
    ADD_INGREDIENT: 'add_ingredient',
    FREQUENCY_INCREASE: 'frequency_increase',
    FREQUENCY_DECREASE: 'frequency_decrease',
    TIMING_CHANGE: 'timing_change',
    SIMPLIFICATION: 'simplification',
};
exports.routineEventTypeEnum = [
    'item_added',
    'item_removed',
    'item_edited',
    'schedule_modified',
    'frequency_increased',
    'frequency_decreased',
    'period_changed',
];
exports.routineChangeImpactEnum = [
    'increased',
    'decreased',
    'modified',
    'started',
    'stopped',
];
/**
 * Types of notifications that can be sent to users
 * - scan_reminder: Scheduled reminders to take daily scans
 * - scan_completion: Notification when scan analysis is ready
 * - report_completion: Notification when skin report generation is ready
 * - weekly_report_skipped: Notification when weekly report is skipped (variant=light)
 * - weekly_report_ready: Notification when weekly report generation completes (rolling mode)
 */
exports.notificationTypeEnum = [
    constants_1.NOTIFICATION_TYPE.SCAN_REMINDER,
    constants_1.NOTIFICATION_TYPE.SCAN_COMPLETION,
    constants_1.NOTIFICATION_TYPE.REPORT_COMPLETION,
    constants_1.NOTIFICATION_TYPE.WEEKLY_REPORT_SKIPPED,
    constants_1.NOTIFICATION_TYPE.WEEKLY_REPORT_READY,
    constants_1.NOTIFICATION_TYPE.FIRST_REPORT_READY,
];
exports.seasonEnum = ['winter', 'spring', 'summer', 'autumn'];
exports.hemisphereEnum = ['northern', 'southern'];
// ============================================================================
// Menstrual Cycle Enums
// ============================================================================
/**
 * Menstrual Cycle Phase
 *
 * Phases of the menstrual cycle for phase-aware skin analysis.
 * - menstrual: Days 1-5, dryness/sensitivity, breakouts may improve
 * - follicular: Days 6-13, skin at its best, balanced sebum
 * - ovulation: Days 14-16, glowing but pores more visible
 * - luteal: Days 17-21+, increased sebum, higher breakout risk
 * - pms: Last 7 days, peak breakout time, inflammation/puffiness
 * - unknown: Cannot determine phase
 */
exports.menstrualPhaseEnum = [
    'menstrual',
    'follicular',
    'ovulation',
    'luteal',
    'pms',
    'unknown',
];
/**
 * Cycle Length Category
 *
 * Simplified cycle length categories for user input.
 * - short: 21-25 days (mapped to 23 days for calculation)
 * - average: 26-30 days (mapped to 28 days for calculation)
 * - long: 31+ days (mapped to 33 days for calculation)
 */
exports.cycleLengthCategoryEnum = ['short', 'average', 'long'];
// ============================================================================
// Report Wizard Enums
// ============================================================================
/**
 * Adherence Answer Type
 *
 * Discriminator for how adherence was determined.
 * - calculated: Derived from routine tracking data
 * - manual: User selected from predefined options
 */
exports.adherenceAnswerTypeEnum = ['calculated', 'manual'];
/**
 * Adherence Selection
 *
 * Manual adherence selection values for wizard answers.
 * Used when user doesn't have calculated adherence data.
 */
exports.adherenceSelectionEnum = [
    'very_inconsistent',
    'half_time',
    'most_time',
    'consistent',
];
/**
 * Lifestyle Question Type
 *
 * The three lifestyle questions asked in the report wizard.
 * Subset of lifestyleFactorEnum focused on daily habits.
 */
exports.lifestyleQuestionEnum = ['sleep', 'stress', 'diet'];
/**
 * Lifestyle Answer Source
 *
 * Source of lifestyle answer data.
 * - calculated: Derived from journal/tracking data
 * - user_reported: Manually selected by user in wizard
 */
exports.lifestyleAnswerSourceEnum = [
    'calculated',
    'user_reported',
];
/**
 * Menstrual Cycle Tracking Type
 *
 * Discriminator for menstrual cycle tracking status.
 * - tracked: User tracks their cycle with dates
 * - not_applicable: User doesn't track or N/A
 */
exports.cycleTrackingTypeEnum = ['tracked', 'not_applicable'];
//# sourceMappingURL=enums.js.map